<template>
  <div class="page-content global-typography">
    <sc-rich-text :field="fields.PageContent" />
  </div>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'AdditionalContent',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        PageContent: '',
      }),
    },
  },
  components: {
    ScRichText: RichText,
  },
  computed: {
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
a:link {
  text-decoration: none;
}

::v-deep {
  p {
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      margin-bottom: 0.8rem;
    }
  }
}
</style>
